import { Modal } from "./Modal";
import { usePersonalCenter } from "../data/PersonalCenterContext";
import { PersonalCenterContent } from "../pages/SettingsPage";

export function PersonalCenterHost() {
  const { open, closePersonalCenter } = usePersonalCenter();
  return (
    <Modal
      open={open}
      title="个人中心"
      eyebrow="账户与偏好"
      onClose={closePersonalCenter}
      drawerWide
      className="personal-center-backdrop"
    >
      <PersonalCenterContent />
    </Modal>
  );
}
